<template>
    <div class="container" >
        <!-- <img @click="goUserCenter('/articleInfo','id')" class="img" :style="comWidth?getImgWidthAndHeight:''" src="@/assets/2.jpg" alt=""> -->
        <div class="artStyle">
            <div>
                <div class="secondTitle" @click="goUserCenter('/articleInfo',articleItem.id)" >{{articleItem.title.length>100?articleItem.title.substring(0,60)+'...':articleItem.title}}</div>
              
                <div class="threeTitle" v-if="linkFrom =='space'" style="padding-top:10px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2; overflow: hidden;padding-right:10px" 
                v-html="articleItem.content.length>100?articleItem.content.substring(0,60)+'...':articleItem.content"></div>
                <div class="threeTitle" v-else style="padding-top:10px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2; overflow: hidden;padding-right:10px" v-html="articleItem.content"></div>
                <div style="padding:10px 0 0 20px;color:#BBBBBB;" v-if="linkFrom != 'caogaoxiang'">
                    <span class="iconfont" style="margin-right:4px;font-size: 18px;vertical-align: middle">&#xe7fd;</span>
                    <span class="iconStyle">{{ articleItem.readCount }}</span>
                    <span class="iconfont" style="margin:0 4px 0 20px;vertical-align: middle">&#xe61a;</span>
                    <span class="iconStyle">{{ articleItem.commentCount }}</span>
                    <span class="iconfont" style="margin:0 4px 0 20px;vertical-align: middle">&#xe62e;</span>
                    <span class="iconStyle">{{ articleItem.likeCount }}</span>
                    <span class="iconfont" style="margin:0 4px 0 20px;vertical-align: middle">&#xe603;</span>
                    <span class="iconStyle">{{ articleItem.collectCount }}</span>
                    <span class="iconfont" style="margin:0 4px 0 20px;vertical-align: middle">&#xe636;</span>
                    <span class="iconStyle" v-if="articleItem.status==0">审核中</span>
                    <span class="iconStyle" v-if="articleItem.status==1">{{ articleItem.updateTimeStr }}</span>
                    <span class="iconStyle" v-if="articleItem.status==2" style="color: red" :title="articleItem.checkSuggest">未通过</span>
                    <span class="iconStyle" v-if="articleItem.status==3">下架</span>
                    <span class="iconStyle" v-if="articleItem.status==4">草稿</span>

                    <span v-if="linkFrom !='space'" >
                      <span @click="delArticle(articleItem.id)">
                        <span class="iconfont" style="margin:0 4px 0 20px;vertical-align: middle">&#xe61e;</span>
                        <span class="iconStyle">删除</span>
                      </span>
                      <span @click="editArticle(articleItem.id)">
                        <span class="iconfont" style="margin:0 4px 0 20px;vertical-align: middle">&#xe690;</span>
                        <span class="iconStyle">编辑</span>
                      </span>
                    </span>
                </div>
            </div>
            <div><img @click="goUserCenter('/articleInfo',articleItem.id)" class="img"  :src="articleItem.cover" alt=""></div>

        </div>
    </div>
</template>
<script>
import {deleteArticle} from "@/comm/api";

export default {
  name: 'ArticleV',
  components: {

  },
  props: {
    articleItem:{},
    comWidth:{
      type:Number,
      default:null,
    },
    comHeight:{
      type:Number,
      default:null,
    },
    linkFrom:{
      //标明数据来源：该页面个人空间、创作中心首页、草稿箱共用
      type:String,
      default:null,
    },

  },
  computed:{
      getImgWidthAndHeight(){

       if(this.comWidth && this.comHeight){
            return "width:"+this.comWidth+"px;"+"height:"+this.comHeight+"px";
       }
       return null;
      }
  },
  data() {
    return {

    }
  },

  methods:{
      goUserCenter(url,id){
        const { href } = this.$router.resolve({
            path: url+"?id="+id
        });

        window.open(href, '_blank');
      },
    async delArticle(id){
      await deleteArticle({id:id});
      this.$emit("submit-loadPage");
      this.$message.success('删除成功');
    },
    editArticle(id){
      let routeData = this.$router.resolve({ path: '/creativeCenter', query: {"viewKey": "4-1","resourceId":id } });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>
<style lang="stylus" scoped>
    .container
        width 100%;
        // height 126px;
        background white;
        border-radius 4px;
        cursor:pointer;
        // margin 20px 0px 0px 0px;

        .artStyle{
            display :flex;
            justify-content :space-between;
            padding-top:22px;
            .iconStyle{
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #BBBBBB;
                    line-height: 17px;

            }

        }
        .fengexian{
            padding-bottom 10px;border-bottom: 1px solid #EEEEEE;
            width :592px;
        }
        .flex-center
            display flex;
            align-items center;
        .img
            width 160px;
            height 100px;
            border-radius 4px 4px 4px 4px;
            cursor:pointer;
            margin-right:18px;
        .article-info
            padding 14px;
            .title
                font-size: 16px;
                font-weight: 600;
                color: #363636;
                line-height: 22px;
                text-align: left;
            .info
                display flex;
                align-items center;
                justify-content space-between;
                padding 30px 0px;
                .img
                    width: 28px;
                    height: 28px;
                    border-radius 50px;
                .desc
                    font-size: 11px;
                    font-weight: 400;
                    color: #363636;
                    line-height: 16px;
                    margin 0px 8px;
                .count
                    font-size: 11px;
                    font-weight: 400;
                    color: #B8B9BA;
                    line-height: 16px;
                    span
                        margin-right 3px;
    .pInfo
        .header
            display flex;
            justify-content space-between;
            align-items center;
            .left
                display flex;
                align-items center;
                .avatar
                    width 40px;
                    height 40px;
                    border-radius 50px;
                    margin-right 8px;
                .title
                    font-size: 16px;
                    font-weight: 400;
                    color: #363636;
                    line-height: 22px;
                .status
                    font-size: 12px;
                    font-weight: 400;
                    color: #999999;
                    line-height: 17px;
            .right-btn
                width: 78px;
                height: 28px;
                background: #F72B17;
                border-radius: 4px;
                border none;
                font-size: 14px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 20px;
        .content
            margin 20px 0px;
            display flex;
            justify-content space-between;
            .pics
                width 92px;
                height 80px;
                border-radius 4px;
                margin-right 10px;
        .footer
            font-size: 12px;
            font-weight: 400;
            color: #BBBBBB;
            line-height: 17px;
            span
                margin-right 15px;

</style>
